var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"events-day-widget-server"}},[(_vm.getGameConsole === 'default')?_c('default-events-day-widget-server'):_vm._e(),(_vm.getGameConsole === 'marketview')?_c('market-view-events-day-widget-server'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }